// extracted by mini-css-extract-plugin
module.exports = {"formText":"customAvatarList_formText__2mH0m","CustomSearchBar":"customAvatarList_CustomSearchBar__2cDga","searchIcon":"customAvatarList_searchIcon__WvMIn"};